import { Button, Typography } from "@mui/material";
import { ETableEditAction } from "../../Utils/Enums";
import { Vocabulary } from "../../Utils/Vocabulary";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import genericStyles from "../../Styles/genericStyles.module.css";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import GenericModal from "../GenericModal";
import { useState } from "react";
import StandardActionButtons from "../StandarsActionButtons";
import HoursForm from "../Hours/HoursForm";
import { HoursPanelProps } from "../../Utils/Types";
import { useParams } from "react-router-dom";
import { endpoints } from "../../Utils/UrlEnum";
import { FormsIds } from "../../Utils/Constants";
import { formatDate } from "../../Utils/Utils";
import { getVehicleLabel } from "../Vehicles/VehicleUtils";
import ModalButton from "../ModalButton";
import SupplimentaryHoursForm from "../Hours/SupplimentaryHoursForm";
import { SupplimentaryHoursFormDefaultState } from "../../Utils/Models";
import { postData } from "../../Services/postData";
import ExamHoursForm from "../Hours/ExamHoursForm";
import withRole from "../../Hooks/withRole";

function HoursPanel(props: HoursPanelProps) {
  const {
    instructors,
    nrOfDrivingHours,
    setTriggerReload,
    triggerReload,
    nrOfSupplimentaryHours,
    instructorId,
    clientId,
    supplementaryHourPrice,
    vehicleId,
  } = props;
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { id } = useParams(); //order id
  const [suplimentaryHour, setSuplimentaryHour] =
    useState<SupplimentaryHoursFormDefaultState>(
      new SupplimentaryHoursFormDefaultState()
    );

  const [errors, setErrors] = useState({
    nrOfHours: null,
    price: null,
    paymentMethod: null,
  });

  /**
   * Validate the supplimentary hours form data.
   * @returns boolean, true if the form is valid, false otherwise.
   */
  const validate = () => {
    const newErrors: any = {};
    if (suplimentaryHour.nrOfHours === null) {
      newErrors.nrOfHours = Vocabulary.requiredField;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /**
   *
   */
  const columns = [
    {
      label: ` `,
      name: "_id",
      options: {
        sort: false,
        display: false,
      },
    },
    {
      label: Vocabulary.day,
      name: "startDate",
      options: {
        sort: false,
        customBodyRender: (object: any) => {
          return formatDate(object);
        },
      },
    },
    {
      label: Vocabulary.startHour,
      name: "startDate",
      options: {
        sort: false,
        customBodyRender: (object: any) => {
          return formatDate(object, "HH:mm");
        },
      },
    },
    {
      label: Vocabulary.endHour,
      name: "endDate",
      options: {
        sort: false,
        customBodyRender: (object: any) => {
          return formatDate(object, "HH:mm");
        },
      },
    },
    {
      label: Vocabulary.instructor,
      name: "instructorId",
      options: {
        sort: false,
        customBodyRender: (object: any) => {
          const userId = object?.user_id;
          if (userId) {
            return userId.firstName + " " + userId.lastName;
          }
        },
      },
    },
    {
      label: Vocabulary.vehicle,
      name: "vehicleId",
      options: {
        sort: false,
        customBodyRender: (object: any) => {
          return getVehicleLabel(object);
        },
      },
    },
    {
      label: Vocabulary.createdAt,
      name: "createdAt",
      options: {
        sort: false,
        customBodyRender: (object: any) => {
          return formatDate(object);
        },
      },
    },
  ];

  /**
   * Returns a JSX element which displays the number of driving hours
   * and sessions in a nice format.
   * @returns {JSX.Element}
   */
  const renderHoursSummary = () => {
    return (
      <div className={genericStyles.subtitle}>
        <Typography fontSize={"1rem"}>
          {`${Vocabulary.hoursDescription}: `}
          <strong>{nrOfDrivingHours}</strong>
          {` / `}
          <strong>{nrOfSupplimentaryHours ?? 0}</strong>
          {` ${Vocabulary.sessions}!`}
        </Typography>
      </div>
    );
  };

  const saveSupplimentaryHours = () => {
    const dataToSend = {
      ...(suplimentaryHour as any),
      orderId: id,
      price:
        Number(supplementaryHourPrice) *
        (Number(suplimentaryHour?.nrOfHours) || 0),
    };
    postData(endpoints.hours.supplimentaryHours, dataToSend).then(
      (response) => {
        if (response && response.data) {
          setTriggerReload(!triggerReload);
          return true;
        }
      }
    );
  };
  /**
   *
   */
  return (
    <div>
      <MUIDataTableCustomStyle
        title={Vocabulary.hours}
        CRUDEndPoint={`${endpoints.hours.orderHours}/${id}`}
        columns={columns}
        onEditAction={ETableEditAction.NONE}
        hideAddButton={true}
        hideEditButton={true}
        hideSearch={true}
        triggerReload={triggerReload}
        setTriggerReload={() =>
          setTriggerReload(triggerReload !== undefined ? !triggerReload : false)
        }
      />
      {renderHoursSummary()}
      <div className={genericStyles.leftButtonsContainer}>
        {props?.addHours && (
          <Button
            startIcon={<DriveEtaIcon />}
            variant="contained"
            color="primary"
            onClick={() => setOpenModal(true)}
          >
            {Vocabulary.addHours}
          </Button>
        )}
        {props?.addSupplementaryHours && (
          <ModalButton
            buttonTitle={Vocabulary.addSupplementeryHours}
            content={
              <SupplimentaryHoursForm
                name={"SupplimentaryHoursForm"}
                suplimentaryHour={suplimentaryHour}
                setSupplimentaryHour={setSuplimentaryHour}
                errors={errors}
                supplementaryHourPrice={supplementaryHourPrice}
              />
            }
            buttonIcon={<AccessTimeIcon />}
            buttonSize="medium"
            saveAction={() => {
              if (validate()) {
                saveSupplimentaryHours();
              } else return false;
            }}
          />
        )}
        {props?.addHours && (
          <ModalButton
            buttonTitle={Vocabulary.addExamHours}
            content={
              <ExamHoursForm
                instructor={instructorId}
                instructors={instructors}
              />
            }
            buttonIcon={<AccessTimeIcon />}
            buttonSize="medium"
            formId={FormsIds.examHours}
            // type="submit"
          />
        )}
      </div>
      <GenericModal
        title={Vocabulary.addHours}
        open={openModal}
        onClose={() => setOpenModal(false)}
        actions={
          <StandardActionButtons
            // okAction={() => deleteElement()}
            cancelAction={() => setOpenModal(false)}
            okText={Vocabulary.save}
            cancelText={Vocabulary.cancel}
            type="submit"
            formId={FormsIds.hours}
          />
        }
      >
        <HoursForm
          onClose={() => {
            setOpenModal(false);
            setTriggerReload(
              triggerReload !== undefined ? !triggerReload : false
            );
          }}
          instructors={instructors}
          showKm
          isInstructor={props?.isInstructor}
          defaultValues={{
            instructorId: instructorId,
            clientId,
            vehicleId,
          }}
        />
      </GenericModal>
    </div>
  );
}

export default withRole(HoursPanel);
